<span class="checkbox-container" [attr.aria-checked]="checked" [attr.aria-disabled]="disabled" (click)="toggle()">
  <input
    type="checkbox"
    [attr.id]="inputId"
    [attr.name]="name || null"
    [attr.aria-checked]="checked ? 'true' : 'false'"
    [checked]="checked"
    [disabled]="disabled"
    (click)="$event.stopPropagation()"
    (change)="onNativeChange($event)"
    (blur)="onBlur()"
  />
  <span class="checkmark"></span>
  <label [attr.for]="inputId" (click)="$event.stopPropagation()">
    <ng-content></ng-content>
  </label>
</span>
